import _ from 'lodash'

export const getShopperTrakState = (state) => _.get(state, 'shopperTrak')
export const getOccupancy = (state) => _.get(getShopperTrakState(state), 'occupants')